import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './_header.scss'

function Header({ logo, alt, theme }) {
  const [hasError, setHasError] = useState(false)
  return logo && !hasError ? (
    <header className={`header${theme ? ` header--${theme}` : ''}`}>
      <img alt={alt} src={logo} className="header__logo" onError={() => setHasError(true)} />
    </header>
  ) : null;
}

Header.propTypes = {
  logo: PropTypes.string,
  alt: PropTypes.string,
  theme: PropTypes.oneOf(['banner']),
}

export default Header
